"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { useTranslations } from "next-intl";
import { useNetlifyForm, netlifyFormMessage } from "@/components/use-netlify-form";
import { FormStatus } from "@/components/form-status";
import { DatePickerField } from "@/components/ui/date-picker";
import { TimePickerField } from "@/components/ui/time-picker";
import workshopData from "@/content/mtb-workshop-services-summer-2025.json";
interface ContactFormProps {
  locale: string;
}
interface BikeService {
  serviceId: string;
  quantity: number;
}
interface Bike {
  id: string;
  type: string;
  brand: string;
  services: BikeService[];
}

// Service category mapping for bike types
const categoryMapping: Record<string, string[]> = {
  enduro: ["bike-maintenance", "suspension-service", "brake-service", "drivetrain-service", "wheel-tire-service", "upgrades-custom"],
  downhill: ["bike-maintenance", "suspension-service", "brake-service", "drivetrain-service", "wheel-tire-service", "upgrades-custom"],
  emtb: ["bike-maintenance", "suspension-service", "brake-service", "drivetrain-service", "wheel-tire-service", "upgrades-custom"],
  kids: ["bike-maintenance", "brake-service", "drivetrain-service", "wheel-tire-service"],
  // No suspension typically
  other: [] // Show all
};
export default function ContactFormSummerWorkshop(t0) {
  const $ = _c(224);
  const {
    locale
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      id: "1",
      type: "",
      brand: "",
      services: []
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [bikes, setBikes] = useState(t1);
  const [sameDayService, setSameDayService] = useState(false);
  const [needsPickup, setNeedsPickup] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [depositDate, setDepositDate] = useState("");
  const t = useTranslations("ContactSummer");
  const today = new Date().toISOString().split("T")[0];
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setBikes([{
        id: "1",
        type: "",
        brand: "",
        services: []
      }]);
      setSameDayService(false);
      setNeedsPickup(false);
      setTotalPrice(0);
      setDepositDate("");
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    status: netlifyStatus,
    handleSubmit: handleNetlifySubmit
  } = useNetlifyForm(t2);
  let t3;
  let t4;
  if ($[2] !== bikes || $[3] !== needsPickup || $[4] !== sameDayService) {
    t3 = () => {
      let total = 0;
      bikes.forEach(bike => {
        bike.services.forEach(service => {
          const serviceData = workshopData.categories.flatMap(_temp).find(s => s.id === service.serviceId);
          if (serviceData) {
            total = total + serviceData.price * service.quantity;
            total;
          }
        });
      });
      if (sameDayService) {
        total = total + 5;
        total;
      }
      if (needsPickup) {
        total = total + 15;
        total;
      }
      setTotalPrice(total);
    };
    t4 = [bikes, sameDayService, needsPickup];
    $[2] = bikes;
    $[3] = needsPickup;
    $[4] = sameDayService;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== bikes) {
    t5 = () => {
      setBikes([...bikes, {
        id: Date.now().toString(),
        type: "",
        brand: "",
        services: []
      }]);
    };
    $[7] = bikes;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const addBike = t5;
  let t6;
  if ($[9] !== bikes) {
    t6 = id => {
      if (bikes.length > 1) {
        setBikes(bikes.filter(bike_0 => bike_0.id !== id));
      }
    };
    $[9] = bikes;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const removeBike = t6;
  let t7;
  if ($[11] !== bikes) {
    t7 = (id_0, field, value) => {
      setBikes(bikes.map(bike_1 => {
        if (bike_1.id === id_0 && field === "type") {
          return {
            ...bike_1,
            [field]: value,
            services: []
          };
        }
        return bike_1.id === id_0 ? {
          ...bike_1,
          [field]: value
        } : bike_1;
      }));
    };
    $[11] = bikes;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const updateBike = t7;
  let t8;
  if ($[13] !== bikes) {
    t8 = (bikeId, serviceId) => {
      setBikes(bikes.map(bike_2 => {
        if (bike_2.id === bikeId) {
          const existingService = bike_2.services.find(s_0 => s_0.serviceId === serviceId);
          if (existingService) {
            return {
              ...bike_2,
              services: bike_2.services.filter(s_1 => s_1.serviceId !== serviceId)
            };
          } else {
            return {
              ...bike_2,
              services: [...bike_2.services, {
                serviceId,
                quantity: 1
              }]
            };
          }
        }
        return bike_2;
      }));
    };
    $[13] = bikes;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const toggleService = t8;
  let t9;
  if ($[15] !== bikes) {
    t9 = (bikeId_0, serviceId_0, quantity) => {
      setBikes(bikes.map(bike_3 => {
        if (bike_3.id === bikeId_0) {
          if (quantity === 0) {
            return {
              ...bike_3,
              services: bike_3.services.filter(s_2 => s_2.serviceId !== serviceId_0)
            };
          } else {
            return {
              ...bike_3,
              services: bike_3.services.map(s_3 => s_3.serviceId === serviceId_0 ? {
                ...s_3,
                quantity
              } : s_3)
            };
          }
        }
        return bike_3;
      }));
    };
    $[15] = bikes;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const updateServiceQuantity = t9;
  const getServicePrice = _temp3;
  const getServiceName = _temp5;
  let t10;
  if ($[17] !== bikes) {
    t10 = (bikeId_1, serviceId_3) => {
      const bike_4 = bikes.find(b => b.id === bikeId_1);
      return bike_4?.services.some(s_6 => s_6.serviceId === serviceId_3) || false;
    };
    $[17] = bikes;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const isServiceSelected = t10;
  let t11;
  if ($[19] !== bikes) {
    t11 = (bikeId_2, serviceId_4) => {
      const bike_5 = bikes.find(b_0 => b_0.id === bikeId_2);
      const service_2 = bike_5?.services.find(s_7 => s_7.serviceId === serviceId_4);
      return service_2?.quantity || 0;
    };
    $[19] = bikes;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const getServiceQuantity = t11;
  const getFilteredCategories = _temp6;
  let t12;
  if ($[21] !== bikes || $[22] !== getServiceName || $[23] !== getServicePrice) {
    t12 = () => {
      const bikesData = bikes.map((bike_6, index) => {
        const bikeServices = bike_6.services.map(service_3 => `${getServiceName(service_3.serviceId)} x${service_3.quantity} (${getServicePrice(service_3.serviceId) * service_3.quantity}€)`).join(", ");
        return `Bike ${index + 1}: ${bike_6.type || "Not specified"} - ${bike_6.brand || "Not specified"}\nServices: ${bikeServices || "None selected"}`;
      }).join("\n\n");
      return bikesData;
    };
    $[21] = bikes;
    $[22] = getServiceName;
    $[23] = getServicePrice;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const prepareFormData = t12;
  let t13;
  let t14;
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <input type="hidden" name="form-name" value="contact-summer-workshop" />;
    t14 = <input type="hidden" name="formType" value="workshop" />;
    t15 = <input type="hidden" name="season" value="summer" />;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
  } else {
    t13 = $[25];
    t14 = $[26];
    t15 = $[27];
  }
  let t16;
  if ($[28] !== prepareFormData) {
    t16 = prepareFormData();
    $[28] = prepareFormData;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t16) {
    t17 = <input type="hidden" name="bikesData" value={t16} />;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = `${totalPrice}€`;
  let t19;
  if ($[32] !== t18) {
    t19 = <input type="hidden" name="totalPrice" value={t18} />;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <p className="hidden"><label>Don't fill this out if you're human:{" "}<input name="bot-field" /></label></p>;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t) {
    t21 = t("firstName");
    $[35] = t;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t21) {
    t22 = <label htmlFor="firstName" className="block text-base font-medium mb-2">{t21} *</label>;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <input type="text" id="firstName" name="firstName" required={true} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== t22) {
    t24 = <div>{t22}{t23}</div>;
    $[40] = t22;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t) {
    t25 = t("lastName");
    $[42] = t;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== t25) {
    t26 = <label htmlFor="lastName" className="block text-base font-medium mb-2">{t25} *</label>;
    $[44] = t25;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <input type="text" id="lastName" name="lastName" required={true} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== t26) {
    t28 = <div>{t26}{t27}</div>;
    $[47] = t26;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== t) {
    t29 = t("email");
    $[49] = t;
    $[50] = t29;
  } else {
    t29 = $[50];
  }
  let t30;
  if ($[51] !== t29) {
    t30 = <label htmlFor="email" className="block text-base font-medium mb-2">{t29} *</label>;
    $[51] = t29;
    $[52] = t30;
  } else {
    t30 = $[52];
  }
  let t31;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <input type="email" id="email" name="email" required={true} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  let t32;
  if ($[54] !== t30) {
    t32 = <div>{t30}{t31}</div>;
    $[54] = t30;
    $[55] = t32;
  } else {
    t32 = $[55];
  }
  let t33;
  if ($[56] !== t) {
    t33 = t("phone");
    $[56] = t;
    $[57] = t33;
  } else {
    t33 = $[57];
  }
  let t34;
  if ($[58] !== t33) {
    t34 = <label htmlFor="phone" className="block text-base font-medium mb-2">{t33}</label>;
    $[58] = t33;
    $[59] = t34;
  } else {
    t34 = $[59];
  }
  let t35;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <input type="tel" id="phone" name="phone" className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[60] = t35;
  } else {
    t35 = $[60];
  }
  let t36;
  if ($[61] !== t34) {
    t36 = <div>{t34}{t35}</div>;
    $[61] = t34;
    $[62] = t36;
  } else {
    t36 = $[62];
  }
  let t37;
  if ($[63] !== t) {
    t37 = t("depositDate");
    $[63] = t;
    $[64] = t37;
  } else {
    t37 = $[64];
  }
  let t38;
  if ($[65] !== t37) {
    t38 = <label htmlFor="depositDate" className="text-base font-medium">{t37} *</label>;
    $[65] = t37;
    $[66] = t38;
  } else {
    t38 = $[66];
  }
  const t39 = locale === "fr" ? "ex: 15/07/2025" : "e.g. 15/07/2025";
  let t40;
  if ($[67] !== t39) {
    t40 = <span className="text-sm text-muted-foreground">{t39}</span>;
    $[67] = t39;
    $[68] = t40;
  } else {
    t40 = $[68];
  }
  let t41;
  if ($[69] !== t38 || $[70] !== t40) {
    t41 = <div className="flex items-center justify-between mb-2">{t38}{t40}</div>;
    $[69] = t38;
    $[70] = t40;
    $[71] = t41;
  } else {
    t41 = $[71];
  }
  const t42 = locale === "fr" ? "Heure de d\xE9p\xF4t" : "Deposit Time";
  let t43;
  if ($[72] !== t42) {
    t43 = <label htmlFor="depositTime" className="text-base font-medium">{t42}</label>;
    $[72] = t42;
    $[73] = t43;
  } else {
    t43 = $[73];
  }
  const t44 = locale === "fr" ? "ex: 10:00" : "e.g. 10:00";
  let t45;
  if ($[74] !== t44) {
    t45 = <span className="text-sm text-muted-foreground">{t44}</span>;
    $[74] = t44;
    $[75] = t45;
  } else {
    t45 = $[75];
  }
  let t46;
  if ($[76] !== t43 || $[77] !== t45) {
    t46 = <div className="flex items-center justify-between mb-2">{t43}{t45}</div>;
    $[76] = t43;
    $[77] = t45;
    $[78] = t46;
  } else {
    t46 = $[78];
  }
  const t47 = locale === "fr" ? "Choisir une heure" : "Pick a time";
  let t48;
  if ($[79] !== t47) {
    t48 = <TimePickerField name="depositTime" id="depositTime" placeholder={t47} />;
    $[79] = t47;
    $[80] = t48;
  } else {
    t48 = $[80];
  }
  let t49;
  if ($[81] !== t46 || $[82] !== t48) {
    t49 = <div>{t46}{t48}</div>;
    $[81] = t46;
    $[82] = t48;
    $[83] = t49;
  } else {
    t49 = $[83];
  }
  let t50;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <div className="flex-shrink-0 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center"><svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" /></svg></div>;
    $[84] = t50;
  } else {
    t50 = $[84];
  }
  let t51;
  if ($[85] !== t) {
    t51 = t("couponTitle");
    $[85] = t;
    $[86] = t51;
  } else {
    t51 = $[86];
  }
  let t52;
  if ($[87] !== t51) {
    t52 = <span className="font-bold text-sm text-foreground">{t51}</span>;
    $[87] = t51;
    $[88] = t52;
  } else {
    t52 = $[88];
  }
  let t53;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <span className="font-bold text-green-600 text-sm">-20%</span>;
    $[89] = t53;
  } else {
    t53 = $[89];
  }
  let t54;
  if ($[90] !== t52) {
    t54 = <div className="flex items-center gap-2 mb-1">{t52}{t53}</div>;
    $[90] = t52;
    $[91] = t54;
  } else {
    t54 = $[91];
  }
  let t55;
  if ($[92] !== t) {
    t55 = t("couponTitle");
    $[92] = t;
    $[93] = t55;
  } else {
    t55 = $[93];
  }
  let t56;
  if ($[94] !== t) {
    t56 = t("couponCodeLabel");
    $[94] = t;
    $[95] = t56;
  } else {
    t56 = $[95];
  }
  let t57;
  if ($[96] !== t55 || $[97] !== t56) {
    t57 = <input type="text" id="couponCode" name="couponCode" aria-label={t55} placeholder={t56} className="w-full px-3 py-2.5 text-base border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-background" />;
    $[96] = t55;
    $[97] = t56;
    $[98] = t57;
  } else {
    t57 = $[98];
  }
  let t58;
  if ($[99] !== t54 || $[100] !== t57) {
    t58 = <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-lg p-4 shadow-sm"><div className="flex items-center gap-4">{t50}<div className="flex-1 min-w-0">{t54}{t57}</div></div></div>;
    $[99] = t54;
    $[100] = t57;
    $[101] = t58;
  } else {
    t58 = $[101];
  }
  const t59 = "lg:col-span-8 space-y-6 pt-6";
  const t60 = locale === "fr" ? "Vos VTTs" : "Your MTBs";
  let t61;
  if ($[102] !== t60) {
    t61 = <h2 className="text-xl font-bold">{t60}</h2>;
    $[102] = t60;
    $[103] = t61;
  } else {
    t61 = $[103];
  }
  const t62 = locale === "fr" ? "Ajouter un VTT" : "Add MTB";
  let t63;
  if ($[104] !== addBike || $[105] !== t62) {
    t63 = <button type="button" onClick={addBike} className="px-4 py-2 bg-secondary text-secondary-foreground rounded-lg font-semibold hover:bg-secondary/90 transition-colors text-sm">+ {t62}</button>;
    $[104] = addBike;
    $[105] = t62;
    $[106] = t63;
  } else {
    t63 = $[106];
  }
  let t64;
  if ($[107] !== t61 || $[108] !== t63) {
    t64 = <div className="flex justify-between items-center mb-4">{t61}{t63}</div>;
    $[107] = t61;
    $[108] = t63;
    $[109] = t64;
  } else {
    t64 = $[109];
  }
  let t65;
  if ($[110] !== bikes || $[111] !== getServicePrice || $[112] !== getServiceQuantity || $[113] !== isServiceSelected || $[114] !== locale || $[115] !== removeBike || $[116] !== t || $[117] !== toggleService || $[118] !== updateBike || $[119] !== updateServiceQuantity) {
    let t66;
    if ($[121] !== bikes.length || $[122] !== getServicePrice || $[123] !== getServiceQuantity || $[124] !== isServiceSelected || $[125] !== locale || $[126] !== removeBike || $[127] !== t || $[128] !== toggleService || $[129] !== updateBike || $[130] !== updateServiceQuantity) {
      t66 = (bike_7, bikeIndex) => <div key={bike_7.id} className="mb-6 p-5 bg-card rounded-xl relative border border-border shadow-sm">{bikes.length > 1 && <button type="button" onClick={() => removeBike(bike_7.id)} className="absolute top-3 right-3 w-9 h-9 rounded-full bg-muted hover:bg-destructive/20 flex items-center justify-center text-muted-foreground hover:text-destructive transition-colors" aria-label="Remove bike">✕</button>}<div className="flex items-center gap-3 mb-4 pb-3 border-b"><div className="w-8 h-8 rounded-full bg-[url('/leather.jpg')] bg-cover bg-center border border-[#2a1f10]/50 flex items-center justify-center text-white"><svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18.5" cy="17.5" r="3.5" /><circle cx="5.5" cy="17.5" r="3.5" /><path d="M15 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-3 11.5V14l-3-3 4-3 2 3h2" /></svg></div><h4 className="font-bold text-lg">{locale === "fr" ? `VTT ${bikeIndex + 1}` : `MTB ${bikeIndex + 1}`}</h4></div><div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4"><div><label htmlFor={`bikeType-${bike_7.id}`} className="block text-base font-medium mb-2">{t("bikeType")}</label><select id={`bikeType-${bike_7.id}`} value={bike_7.type} onChange={e => updateBike(bike_7.id, "type", e.target.value)} className="w-full px-4 py-3 text-base pr-10 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%3E%3cpath%20fill%3D%22%236b7280%22%20d%3D%22M10.293%203.293L6%207.586%201.707%203.293A1%201%200%2000.293%204.707l5%205a1%201%200%20001.414%200l5-5a1%201%200%2000-1.414-1.414z%22%2F%3E%3c%2Fsvg%3E')] bg-[length:12px] bg-[right_12px_center] bg-no-repeat"><option value="">{locale === "fr" ? "S\xE9lectionner..." : "Select..."}</option><option value="enduro">{t("enduro")}</option><option value="downhill">{t("downhill")}</option><option value="emtb">{t("emtb")}</option><option value="kids">{t("kids")}</option><option value="other">{locale === "fr" ? "Autre" : "Other"}</option></select></div><div><label htmlFor={`bikeBrand-${bike_7.id}`} className="block text-base font-medium mb-2">{locale === "fr" ? "Marque" : "Brand"}</label><input type="text" id={`bikeBrand-${bike_7.id}`} value={bike_7.brand} onChange={e_0 => updateBike(bike_7.id, "brand", e_0.target.value)} placeholder="e.g., Specialized, Trek, Canyon..." className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" /></div></div>{bike_7.type && <div className="mt-4 pt-4 border-t"><h5 className="font-medium text-base mb-3">{locale === "fr" ? "Services Atelier" : "Workshop Services"}<span className="text-xs text-muted-foreground ml-2">{locale === "fr" ? "(Cliquez pour s\xE9lectionner)" : "(Click to select)"}</span></h5>{getFilteredCategories(bike_7.type).map(category => <div key={category.id} className="mb-3"><h6 className="text-sm font-semibold text-foreground mb-2">{category.name}</h6><div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">{category.services.map(service_4 => {
                const isSelected = isServiceSelected(bike_7.id, service_4.id);
                const quantity_0 = getServiceQuantity(bike_7.id, service_4.id);
                return <div key={service_4.id} role="checkbox" aria-checked={isSelected} tabIndex={0} onClick={() => toggleService(bike_7.id, service_4.id)} onKeyDown={e_1 => {
                  if (e_1.key === "Enter" || e_1.key === " ") {
                    e_1.preventDefault();
                    toggleService(bike_7.id, service_4.id);
                  }
                }} className={`p-3 rounded-lg border-2 cursor-pointer transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ${isSelected ? "border-primary bg-primary/20 shadow-sm" : "border-muted-foreground/30 bg-background hover:border-primary/60 hover:bg-muted/50"}`}><div className="flex justify-between items-start gap-2"><div className="flex-1 min-w-0"><div className="font-semibold text-sm truncate">{service_4.name}</div><div className="text-xs text-muted-foreground mt-0.5 font-medium">{service_4.price}€ • {service_4.duration}</div></div>{isSelected && <div className="flex items-center gap-1" onClick={_temp7}><button type="button" aria-label={locale === "fr" ? "Diminuer la quantit\xE9" : "Decrease quantity"} onClick={() => updateServiceQuantity(bike_7.id, service_4.id, Math.max(0, quantity_0 - 1))} className="w-9 h-9 rounded bg-muted hover:bg-muted/80 flex items-center justify-center text-sm font-bold">−</button><span className="w-6 text-center text-sm font-semibold">{quantity_0}</span><button type="button" aria-label={locale === "fr" ? "Augmenter la quantit\xE9" : "Increase quantity"} onClick={() => updateServiceQuantity(bike_7.id, service_4.id, quantity_0 + 1)} className="w-9 h-9 rounded bg-primary text-primary-foreground hover:bg-primary/90 flex items-center justify-center text-sm font-bold">+</button></div>}</div></div>;
              })}</div></div>)}</div>}{!bike_7.type && <div className="mt-3 p-3 bg-muted/50 rounded text-sm text-muted-foreground text-center">{locale === "fr" ? "S\xE9lectionnez un type de VTT pour voir les services disponibles" : "Select MTB type to see available services"}</div>}{bike_7.services.length > 0 && <div className="mt-3 p-2 bg-primary/10 rounded-lg border-l-4 border-primary"><div className="text-sm font-semibold flex justify-between"><span>{locale === "fr" ? "Sous-total:" : "Subtotal:"}</span><span className="text-primary">{bike_7.services.reduce((sum, s_8) => sum + getServicePrice(s_8.serviceId) * s_8.quantity, 0)}€</span></div></div>}</div>;
      $[121] = bikes.length;
      $[122] = getServicePrice;
      $[123] = getServiceQuantity;
      $[124] = isServiceSelected;
      $[125] = locale;
      $[126] = removeBike;
      $[127] = t;
      $[128] = toggleService;
      $[129] = updateBike;
      $[130] = updateServiceQuantity;
      $[131] = t66;
    } else {
      t66 = $[131];
    }
    t65 = bikes.map(t66);
    $[110] = bikes;
    $[111] = getServicePrice;
    $[112] = getServiceQuantity;
    $[113] = isServiceSelected;
    $[114] = locale;
    $[115] = removeBike;
    $[116] = t;
    $[117] = toggleService;
    $[118] = updateBike;
    $[119] = updateServiceQuantity;
    $[120] = t65;
  } else {
    t65 = $[120];
  }
  let t66;
  if ($[132] !== t64 || $[133] !== t65) {
    t66 = <div>{t64}{t65}</div>;
    $[132] = t64;
    $[133] = t65;
    $[134] = t66;
  } else {
    t66 = $[134];
  }
  let t67;
  if ($[135] !== t) {
    t67 = t("message");
    $[135] = t;
    $[136] = t67;
  } else {
    t67 = $[136];
  }
  let t68;
  if ($[137] !== t67) {
    t68 = <label htmlFor="message" className="block text-base font-medium mb-2">{t67}</label>;
    $[137] = t67;
    $[138] = t68;
  } else {
    t68 = $[138];
  }
  const t69 = locale === "fr" ? "D\xE9crivez vos besoins sp\xE9cifiques, l'\xE9tat du v\xE9lo, ou toute autre information pertinente..." : "Describe your specific needs, bike condition, or any other relevant information...";
  let t70;
  if ($[139] !== t69) {
    t70 = <textarea id="message" name="message" rows={6} placeholder={t69} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" />;
    $[139] = t69;
    $[140] = t70;
  } else {
    t70 = $[140];
  }
  let t71;
  if ($[141] !== t68 || $[142] !== t70) {
    t71 = <div>{t68}{t70}</div>;
    $[141] = t68;
    $[142] = t70;
    $[143] = t71;
  } else {
    t71 = $[143];
  }
  let t72;
  if ($[144] !== t) {
    t72 = t("dueDate");
    $[144] = t;
    $[145] = t72;
  } else {
    t72 = $[145];
  }
  let t73;
  if ($[146] !== t72) {
    t73 = <label htmlFor="dueDate" className="text-base font-medium">{t72}</label>;
    $[146] = t72;
    $[147] = t73;
  } else {
    t73 = $[147];
  }
  const t74 = locale === "fr" ? "ex: 20/07/2025" : "e.g. 20/07/2025";
  let t75;
  if ($[148] !== t74) {
    t75 = <span className="text-sm text-muted-foreground">{t74}</span>;
    $[148] = t74;
    $[149] = t75;
  } else {
    t75 = $[149];
  }
  let t76;
  if ($[150] !== t73 || $[151] !== t75) {
    t76 = <div className="flex items-center justify-between mb-2">{t73}{t75}</div>;
    $[150] = t73;
    $[151] = t75;
    $[152] = t76;
  } else {
    t76 = $[152];
  }
  const T0 = DatePickerField;
  const t77 = "dueDate";
  const t78 = "dueDate";
  const t79 = depositDate ? new Date(depositDate) : new Date(today);
  const t80 = locale === "fr" ? "Choisir une date" : "Pick a date";
  let t81;
  if ($[153] !== T0 || $[154] !== locale || $[155] !== t79 || $[156] !== t80) {
    t81 = <T0 name={t77} id={t78} locale={locale} minDate={t79} placeholder={t80} />;
    $[153] = T0;
    $[154] = locale;
    $[155] = t79;
    $[156] = t80;
    $[157] = t81;
  } else {
    t81 = $[157];
  }
  let t82;
  if ($[158] !== t76 || $[159] !== t81) {
    t82 = <div>{t76}{t81}</div>;
    $[158] = t76;
    $[159] = t81;
    $[160] = t82;
  } else {
    t82 = $[160];
  }
  let t83;
  if ($[161] === Symbol.for("react.memo_cache_sentinel")) {
    t83 = e_3 => setSameDayService(e_3.target.checked);
    $[161] = t83;
  } else {
    t83 = $[161];
  }
  let t84;
  if ($[162] !== sameDayService) {
    t84 = <input type="checkbox" name="sameDayService" checked={sameDayService} onChange={t83} className="mt-0.5 w-5 h-5 text-primary border-gray-300 rounded focus:ring-2 focus:ring-primary" />;
    $[162] = sameDayService;
    $[163] = t84;
  } else {
    t84 = $[163];
  }
  let t85;
  if ($[164] !== t) {
    t85 = t("sameDayService");
    $[164] = t;
    $[165] = t85;
  } else {
    t85 = $[165];
  }
  let t86;
  if ($[166] !== t85) {
    t86 = <span className="font-medium text-sm text-foreground">{t85} (+5€)</span>;
    $[166] = t85;
    $[167] = t86;
  } else {
    t86 = $[167];
  }
  const t87 = locale === "fr" ? "Service express le jour m\xEAme selon disponibilit\xE9." : "Express same-day service subject to availability.";
  let t88;
  if ($[168] !== t87) {
    t88 = <p className="text-xs text-muted-foreground mt-0.5">{t87}</p>;
    $[168] = t87;
    $[169] = t88;
  } else {
    t88 = $[169];
  }
  let t89;
  if ($[170] !== t86 || $[171] !== t88) {
    t89 = <div className="flex-1">{t86}{t88}</div>;
    $[170] = t86;
    $[171] = t88;
    $[172] = t89;
  } else {
    t89 = $[172];
  }
  let t90;
  if ($[173] !== t84 || $[174] !== t89) {
    t90 = <div className="border rounded-lg p-3 bg-card"><label className="flex items-start gap-3 cursor-pointer">{t84}{t89}</label></div>;
    $[173] = t84;
    $[174] = t89;
    $[175] = t90;
  } else {
    t90 = $[175];
  }
  let t91;
  if ($[176] === Symbol.for("react.memo_cache_sentinel")) {
    t91 = e_4 => setNeedsPickup(e_4.target.checked);
    $[176] = t91;
  } else {
    t91 = $[176];
  }
  let t92;
  if ($[177] !== needsPickup) {
    t92 = <input type="checkbox" name="needsPickup" checked={needsPickup} onChange={t91} className="mt-0.5 w-5 h-5 text-primary border-gray-300 rounded focus:ring-2 focus:ring-primary" />;
    $[177] = needsPickup;
    $[178] = t92;
  } else {
    t92 = $[178];
  }
  let t93;
  if ($[179] !== t) {
    t93 = t("pickupDeliveryService");
    $[179] = t;
    $[180] = t93;
  } else {
    t93 = $[180];
  }
  let t94;
  if ($[181] !== t93) {
    t94 = <span className="font-medium text-sm text-foreground">{t93} (+15€)</span>;
    $[181] = t93;
    $[182] = t94;
  } else {
    t94 = $[182];
  }
  const t95 = locale === "fr" ? "Prise en charge et livraison dans un rayon de 20km." : "Pickup and delivery within 20km radius.";
  let t96;
  if ($[183] !== t95) {
    t96 = <p className="text-xs text-muted-foreground mt-0.5">{t95}</p>;
    $[183] = t95;
    $[184] = t96;
  } else {
    t96 = $[184];
  }
  let t97;
  if ($[185] !== t94 || $[186] !== t96) {
    t97 = <div className="flex-1">{t94}{t96}</div>;
    $[185] = t94;
    $[186] = t96;
    $[187] = t97;
  } else {
    t97 = $[187];
  }
  let t98;
  if ($[188] !== t92 || $[189] !== t97) {
    t98 = <label className="flex items-start gap-3 cursor-pointer">{t92}{t97}</label>;
    $[188] = t92;
    $[189] = t97;
    $[190] = t98;
  } else {
    t98 = $[190];
  }
  let t99;
  if ($[191] !== needsPickup || $[192] !== t) {
    t99 = needsPickup && <div className="mt-3 space-y-4 pt-3 border-t"><div><label htmlFor="pickupAddress" className="block text-base font-medium mb-2">{t("pickupAddress")} *</label><input type="text" id="pickupAddress" name="pickupAddress" required={needsPickup} placeholder={t("pickupAddressPlaceholder")} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" /></div><div className="grid grid-cols-1 md:grid-cols-3 gap-4"><div><label htmlFor="pickupCity" className="block text-base font-medium mb-2">{t("city")} *</label><input type="text" id="pickupCity" name="pickupCity" required={needsPickup} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" /></div><div><label htmlFor="pickupPostalCode" className="block text-base font-medium mb-2">{t("postalCode")} *</label><input type="text" id="pickupPostalCode" name="pickupPostalCode" required={needsPickup} className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" /></div><div><label htmlFor="pickupPhone" className="block text-base font-medium mb-2">{t("pickupPhone")} *</label><input type="tel" id="pickupPhone" name="pickupPhone" required={needsPickup} placeholder="+33..." className="w-full px-4 py-3 text-base border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background" /></div></div></div>;
    $[191] = needsPickup;
    $[192] = t;
    $[193] = t99;
  } else {
    t99 = $[193];
  }
  let t100;
  if ($[194] !== t98 || $[195] !== t99) {
    t100 = <div className="border rounded-lg p-3 bg-card">{t98}{t99}</div>;
    $[194] = t98;
    $[195] = t99;
    $[196] = t100;
  } else {
    t100 = $[196];
  }
  let t101;
  if ($[197] !== bikes || $[198] !== getServiceName || $[199] !== getServicePrice || $[200] !== locale || $[201] !== needsPickup || $[202] !== sameDayService || $[203] !== totalPrice) {
    t101 = bikes.some(_temp8) && <div className="bg-muted/30 border rounded-xl p-6"><div className="flex justify-between items-center mb-5 pb-4 border-b"><h2 className="text-2xl font-bold text-foreground">{locale === "fr" ? "R\xE9capitulatif" : "Summary"}</h2><div className="text-3xl font-bold text-foreground">{totalPrice}€</div></div><div className="space-y-3"><div className="text-base font-bold text-foreground mb-3">{locale === "fr" ? "Services s\xE9lectionn\xE9s:" : "Selected services:"}</div>{bikes.map((bike_8, index_0) => {
          if (bike_8.services.length === 0) {
            return null;
          }
          return <div key={bike_8.id} className="bg-background border rounded-lg p-4"><div className="flex justify-between items-start mb-2"><div className="font-bold text-base text-foreground">{locale === "fr" ? `VTT ${index_0 + 1}` : `MTB ${index_0 + 1}`}{bike_8.type && <span className="text-muted-foreground font-medium ml-1">- {bike_8.type}</span>}</div><span className="font-bold text-base text-foreground">{bike_8.services.reduce((sum_0, s_9) => sum_0 + getServicePrice(s_9.serviceId) * s_9.quantity, 0)}€</span></div><div className="space-y-1">{bike_8.services.map(service_5 => <div key={service_5.serviceId} className="flex justify-between text-sm font-medium text-muted-foreground pl-2"><span>{getServiceName(service_5.serviceId)}{service_5.quantity > 1 && <span>{" "}×{service_5.quantity}</span>}</span><span>{getServicePrice(service_5.serviceId) * service_5.quantity}€</span></div>)}</div></div>;
        })}{sameDayService && <div className="bg-background border rounded-lg p-4"><div className="flex justify-between items-start"><div className="font-bold text-base text-foreground">{locale === "fr" ? "Service express" : "Express service"}</div><span className="font-bold text-base text-foreground">+5€</span></div><div className="text-sm font-medium text-muted-foreground">{locale === "fr" ? "Service le jour m\xEAme" : "Same-day service"}</div></div>}{needsPickup && <div className="bg-background border rounded-lg p-4"><div className="flex justify-between items-start"><div className="font-bold text-base text-foreground">{locale === "fr" ? "Enl\xE8vement & livraison" : "Pickup & delivery"}</div><span className="font-bold text-base text-foreground">+15€</span></div><div className="text-sm font-medium text-muted-foreground">{locale === "fr" ? "Prise en charge et retour" : "Pickup and return"}</div></div>}</div><div className="text-xs text-muted-foreground bg-muted/20 p-3 rounded-lg mt-4">{locale === "fr" ? "\uD83D\uDCA1 Prix estim\xE9 - Pi\xE8ces d\xE9tach\xE9es en suppl\xE9ment" : "\uD83D\uDCA1 Estimated price - Spare parts charged separately"}</div>{workshopData.notes && <div className="mt-4 pt-4 border-t text-xs space-y-1.5"><p>• <strong>{workshopData.notes.warrantyTitle}:</strong>{" "}{workshopData.notes.warranty}</p></div>}</div>;
    $[197] = bikes;
    $[198] = getServiceName;
    $[199] = getServicePrice;
    $[200] = locale;
    $[201] = needsPickup;
    $[202] = sameDayService;
    $[203] = totalPrice;
    $[204] = t101;
  } else {
    t101 = $[204];
  }
  const t102 = netlifyStatus === "submitting";
  let t103;
  if ($[205] !== locale || $[206] !== netlifyStatus || $[207] !== t) {
    t103 = netlifyStatus === "submitting" ? netlifyFormMessage(locale, "submitting") : t("submitButton");
    $[205] = locale;
    $[206] = netlifyStatus;
    $[207] = t;
    $[208] = t103;
  } else {
    t103 = $[208];
  }
  let t104;
  if ($[209] !== t102 || $[210] !== t103) {
    t104 = <button type="submit" disabled={t102} className="w-full bg-primary text-primary-foreground px-6 py-4 text-lg rounded-lg font-semibold hover:bg-primary/90 transition-colors shadow-md hover:shadow-lg disabled:opacity-60">{t103}</button>;
    $[209] = t102;
    $[210] = t103;
    $[211] = t104;
  } else {
    t104 = $[211];
  }
  let t105;
  if ($[212] !== locale || $[213] !== netlifyStatus) {
    t105 = <FormStatus status={netlifyStatus} locale={locale} />;
    $[212] = locale;
    $[213] = netlifyStatus;
    $[214] = t105;
  } else {
    t105 = $[214];
  }
  let t106;
  if ($[215] !== t100 || $[216] !== t101 || $[217] !== t104 || $[218] !== t105 || $[219] !== t66 || $[220] !== t71 || $[221] !== t82 || $[222] !== t90) {
    t106 = <div className={t59}>{t66}{t71}{t82}{t90}{t100}{t101}{t104}{t105}</div>;
    $[215] = t100;
    $[216] = t101;
    $[217] = t104;
    $[218] = t105;
    $[219] = t66;
    $[220] = t71;
    $[221] = t82;
    $[222] = t90;
    $[223] = t106;
  } else {
    t106 = $[223];
  }
  return <div className="bg-card rounded-lg border p-4 sm:p-6 lg:p-8 w-full max-w-[1440px] mx-auto"><form name="contact-summer-workshop" method="POST" data-netlify="true" netlify-honeypot="bot-field" onSubmit={handleNetlifySubmit} className="space-y-6">{t13}{t14}{t15}{t17}{t19}{t20}<div className="grid grid-cols-1 lg:grid-cols-12 gap-6"><div className="lg:col-span-4 space-y-4 lg:p-6 lg:bg-muted/30 lg:rounded-lg">{t24}{t28}{t32}{t36}<div>{t41}<DatePickerField name="depositDate" id="depositDate" locale={locale} required={true} minDate={new Date(today)} value={depositDate} onValueChange={setDepositDate} placeholder={locale === "fr" ? "Choisir une date" : "Pick a date"} /></div>{t49}{t58}</div>{t106}</div></form></div>;
}
function _temp8(b_1) {
  return b_1.services.length > 0;
}
function _temp7(e_2) {
  return e_2.stopPropagation();
}
function _temp6(bikeType) {
  if (!bikeType || bikeType === "other") {
    return workshopData.categories;
  }
  const allowedCategories = categoryMapping[bikeType] || [];
  return workshopData.categories.filter(cat_2 => allowedCategories.includes(cat_2.id));
}
function _temp5(serviceId_2) {
  const service_1 = workshopData.categories.flatMap(_temp4).find(s_5 => s_5.id === serviceId_2);
  return service_1 ? service_1.name : "";
}
function _temp4(cat_1) {
  return cat_1.services;
}
function _temp3(serviceId_1) {
  const service_0 = workshopData.categories.flatMap(_temp2).find(s_4 => s_4.id === serviceId_1);
  return service_0 ? service_0.price : 0;
}
function _temp2(cat_0) {
  return cat_0.services;
}
function _temp(cat) {
  return cat.services;
}